import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'backdrop-blur-md shadow-sm' : ''
      }`}
      style={{
        backgroundColor: scrolled ? 'rgba(253, 246, 233, 0.95)' : 'transparent',
      }}
    >
      <div className="max-w-[1800px] mx-auto px-8 py-6">
        <div className="flex items-center justify-between">
          {/* Left Menu */}
          <div className="hidden lg:flex items-center space-x-12">
            <Link
              to="/collection"
              className="text-sm tracking-[0.2em] uppercase transition-opacity hover:opacity-70"
              style={{ color: 'var(--atelier-black)' }}
            >
              Collectie
            </Link>
            <a
              href="#story"
              className="text-sm tracking-[0.2em] uppercase transition-opacity hover:opacity-70"
              style={{ color: 'var(--atelier-black)' }}
            >
              Verhaal
            </a>
          </div>

          {/* Center Logo */}
          <Link to="/" className="flex-shrink-0">
            <h1
              className="text-2xl lg:text-3xl tracking-[0.3em] font-light"
              style={{ color: 'var(--atelier-black)' }}
            >
              PENOTTI ATELIER
            </h1>
          </Link>

          {/* Right Menu */}
          <div className="hidden lg:flex items-center space-x-12">
            <a
              href="#ingredients"
              className="text-sm tracking-[0.2em] uppercase transition-opacity hover:opacity-70"
              style={{ color: 'var(--atelier-black)' }}
            >
              Ingrediënten
            </a>
            <a
              href="#manifesto"
              className="text-sm tracking-[0.2em] uppercase transition-opacity hover:opacity-70"
              style={{ color: 'var(--atelier-black)' }}
            >
              Filosofie
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{ color: 'var(--atelier-black)' }}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-6 pb-4 space-y-4 border-t pt-4" style={{ borderColor: 'var(--atelier-gold-light)' }}>
            <Link
              to="/collection"
              className="block text-sm tracking-[0.2em] uppercase transition-opacity hover:opacity-70"
              style={{ color: 'var(--atelier-black)' }}
              onClick={() => setMobileMenuOpen(false)}
            >
              Collectie
            </Link>
            <a
              href="#story"
              className="block text-sm tracking-[0.2em] uppercase transition-opacity hover:opacity-70"
              style={{ color: 'var(--atelier-black)' }}
              onClick={() => setMobileMenuOpen(false)}
            >
              Verhaal
            </a>
            <a
              href="#ingredients"
              className="block text-sm tracking-[0.2em] uppercase transition-opacity hover:opacity-70"
              style={{ color: 'var(--atelier-black)' }}
              onClick={() => setMobileMenuOpen(false)}
            >
              Ingrediënten
            </a>
            <a
              href="#manifesto"
              className="block text-sm tracking-[0.2em] uppercase transition-opacity hover:opacity-70"
              style={{ color: 'var(--atelier-black)' }}
              onClick={() => setMobileMenuOpen(false)}
            >
              Filosofie
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;